import React from 'react';

const WarningIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.2581 4.87508L11.3081 2.01675C10.4998 1.55008 9.49977 1.55008 8.68311 2.01675L3.74144 4.87508C2.93311 5.34175 2.43311 6.20841 2.43311 7.15008V12.8501C2.43311 13.7834 2.93311 14.6501 3.74144 15.1251L8.69144 17.9834C9.49977 18.4501 10.4998 18.4501 11.3164 17.9834L16.2664 15.1251C17.0748 14.6584 17.5748 13.7917 17.5748 12.8501V7.15008C17.5664 6.20841 17.0664 5.35008 16.2581 4.87508ZM9.37477 6.45841C9.37477 6.11675 9.65811 5.83341 9.99977 5.83341C10.3414 5.83341 10.6248 6.11675 10.6248 6.45841V10.8334C10.6248 11.1751 10.3414 11.4584 9.99977 11.4584C9.65811 11.4584 9.37477 11.1751 9.37477 10.8334V6.45841ZM10.7664 13.8584C10.7248 13.9584 10.6664 14.0501 10.5914 14.1334C10.4331 14.2917 10.2248 14.3751 9.99977 14.3751C9.89144 14.3751 9.7831 14.3501 9.6831 14.3084C9.57477 14.2667 9.49144 14.2084 9.40811 14.1334C9.33311 14.0501 9.27477 13.9584 9.22477 13.8584C9.1831 13.7584 9.16644 13.6501 9.16644 13.5417C9.16644 13.3251 9.24977 13.1084 9.40811 12.9501C9.49144 12.8751 9.57477 12.8167 9.6831 12.7751C9.99144 12.6417 10.3581 12.7167 10.5914 12.9501C10.6664 13.0334 10.7248 13.1167 10.7664 13.2251C10.8081 13.3251 10.8331 13.4334 10.8331 13.5417C10.8331 13.6501 10.8081 13.7584 10.7664 13.8584Z",
      fill: "#B40000"
    }
  )
);
WarningIcon.displayName = "Icons.WarningIcon";

export { WarningIcon };
//# sourceMappingURL=WarningIcon.js.map
